import gql from 'graphql-tag';

const CLUB_PRESIDENT_CHANGE = gql`
mutation clubPresidentChange($id:ID!, $memberId: ID!){
  clubPresidentChange(id:$id, memberId:$memberId)
}
`;

export default CLUB_PRESIDENT_CHANGE;